import { FC, useEffect, useState } from 'react';
import { getFormattedDateDifference } from '@util/date';

export type DateDifferenceProps = {
    date: Date;
};

export const DateDifference: FC<DateDifferenceProps> = (props: DateDifferenceProps) => {
    const { date } = props;

    const [, setVersion] = useState(0);
    const time = getFormattedDateDifference(date, new Date());

    useEffect(() => {
        const refresh = () => setVersion((v) => v + 1);
        const timer = setInterval(refresh, 60 * 1000);
        return () => {
            clearInterval(timer);
        };
    }, []);

    return <>{time}</>;
};
